import { useTranslation } from "react-i18next";
import { InboxOutlined, InfoCircleFilled } from "@ant-design/icons";
import { Modal, Progress, Upload } from "antd";
import type { UploadProps } from "antd/es/upload";
import { RcFile } from "antd/es/upload";
import React, { useEffect, useState } from "react";

const { Dragger } = Upload;

interface ImportCommonModalProps {
  open: boolean;
  handleCancel: () => void;
  onImport: (formData: FormData) => void | Promise<void>;
  title: string;
  okText?: string;
  cancelText?: string;
  downloadTemplate?: () => void;
}

const ImportCommonModal: React.FC<ImportCommonModalProps> = ({
  open,
  handleCancel,
  onImport,
  title,
  okText = "Tải lên",
  cancelText = "Hủy",
  downloadTemplate
}) => {
  const { t } = useTranslation();
  const [file, setFile] = useState<File | null>(null);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [confirmModalVisible, setConfirmModalVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [uploadKey, setUploadKey] = useState(Date.now());

  const fakeUploadProgress = (selectedFile: RcFile) => {
    setFile(selectedFile);
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress >= 100) {
        clearInterval(interval);
      }
    }, 300);
  };

  const uploadProps: UploadProps = {
    name: "file",
    multiple: false,
    maxCount: 1,
    beforeUpload: (selectedFile) => {
      fakeUploadProgress(selectedFile);
      return false;
    },
    onRemove: () => {
      setFile(null);
      setUploadProgress(0);
    },
    showUploadList: true,
  };

  const handleOk = () => {
    setConfirmModalVisible(true);
  };

  const handleConfirmImport = async () => {
    setIsLoading(true)
    try {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        await onImport(formData);
      }
      setConfirmModalVisible(false);
      handleCancel();
    } catch (error) {

    }
    finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    setFile(null);
    setUploadProgress(0);
    setUploadKey(Date.now());
  }, [open]);

  return (
    <>
      <Modal
        title={title}
        open={open}
        onCancel={handleCancel}
        onOk={handleOk}
        okText={okText}
        cancelText={cancelText}
        centered
        maskClosable={false}
      >
        <div className="gray-color">
          <Dragger {...uploadProps}
            key={uploadKey}
            showUploadList={false}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {t("Nhấn hoặc thả tệp lên từ máy tính của bạn", "Nhấn hoặc thả tệp lên từ máy tính của bạn")}{" "}
              <span className="text-[#1677FF]">{t("vào đây", "vào đây")}</span>
            </p>
          </Dragger>
          {uploadProgress > 0 &&
            <Progress percent={uploadProgress} />}
          {uploadProgress < 100 && uploadProgress > 0 &&
            <div className="loader-upload-file" data-text={t("Hệ thống đang xử lý, xin vui lòng chờ.....", "Hệ thống đang xử lý, xin vui lòng chờ.....")}></div>
          }
          {uploadProgress === 100 && <div>{file?.name}</div>}          <div className="pt-3">
            <span className="font-bold">
              {t("Hướng dẫn các bước thêm sinh viên từ file Excel:", "Hướng dẫn các bước thêm sinh viên từ file Excel:")}
            </span>
            <ol className="list-decimal px-4">
              <li className="list-decimal">
                {t("Tải mẫu file Excel mà bạn cần sử dụng", "Tải mẫu file Excel mà bạn cần sử dụng")}{" "}
                <span
                  className="text-[#1677FF] cursor-pointer"
                  onClick={downloadTemplate}
                >
                  {t("tại đây", "tại đây")}
                </span>
              </li>
              <li className="list-decimal">
                {t("Nhấn hoặc thả tệp cần tải lên vào khu vực tải tệp", "Nhấn hoặc thả tệp cần tải lên vào khu vực tải tệp")}
              </li>
              <li className="list-decimal">
                {t("Chọn nút “Lưu“ để tải file lên hệ thống", "Chọn nút “Lưu“ để tải file lên hệ thống")}
              </li>
            </ol>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div className="flex align-center gap-16">
            {/* <img
							className="confirm-modal-icon"
							src={`${process.env.PUBLIC_URL}/assets/icons/warning-orange-icon.svg`}
							alt={"icon"}
						/> */}
            <InfoCircleFilled
              style={{ color: "#faad14", fontSize: "22px" }}
            />
            {t("Xác nhận tải dữ liệu", "Xác nhận tải dữ liệu")}
          </div>
        }

        open={confirmModalVisible}
        onOk={handleConfirmImport}
        onCancel={() => setConfirmModalVisible(false)}
        okText={t("Đồng ý", "Đồng ý")}
        cancelText={t("Hủy bỏ", "Hủy bỏ")}
        centered
        width={"400px"}
        confirmLoading={isLoading}
      >
        <p>{t("Bạn có chắc chắn muốn import file này?", "Bạn có chắc chắn muốn import file này?")}</p>
      </Modal>
    </>
  );
};

export default ImportCommonModal;
